import React from "react"

import ReCaptchaProvider from "context/recaptcha"

export const wrapRootElement = ({ element }) => (
  <ReCaptchaProvider>{element}</ReCaptchaProvider>
)
